<app-question-card>
  <p question *ngIf="!editMode">{{ isReferralJourney ? "Confirm address and get your cash offer." : "How would you like to proceed?" }}</p>

  <div class="box-c" input-options *ngIf="!editMode">
    <div class="flex-box-center">
      <img *ngIf="img$ | async; let img" [src]="img" alt="house" class="house-img" />
      <div class="house-desc">
        <h6 *ngIf="offerJourney.addressComponent; else fullAddress" class="text-size-18 fw-600">
          {{offerJourney.addressComponent.doorNumber}} {{offerJourney.addressComponent.street}} <br />
          <span class="mt-1 d-block">
            {{ offerJourney.addressComponent.city }}, {{ offerJourney.addressComponent.state }} {{ offerJourney.addressComponent.zip }}
          </span>
        </h6>
        <ng-template #fullAddress>
          <h6>{{offerJourney.vars.address}}</h6>
        </ng-template>
      </div>
    </div>
    <button class="link ml-2" (click)="toggleEdit()">Edit</button>
  </div>

  <div class="box-c flex-box-align-start flex-box-gap-1 mt-2 red" input-options *ngIf="isInvalidAddress && !editMode">
    <lib-icon class="text-color-red min-width-18 text-size-18">info-filled</lib-icon>
    <p class="text-size-14 fw-500">
      Oops, the address seems to be invalid. Please enter a valid address
      <button class="link d-inline fw-500 text-size-14" (click)="toggleEdit();">here</button>
      to proceed.
    </p>
  </div>

  <p class="chat-answer" answer *ngIf="!editMode">{{selectedChoiceName}}</p>

  <div class="form-field mt-20" input-options *ngIf="!editMode">
    <div class="radio-option-arrow" *ngFor="let choice of formChoices">
      <input type="radio" [id]="choice.name" [name]="choice.name" [value]="choice.description" />
      <label [for]="choice.name" (click)="!isInvalidAddress && next(choice)">
        <div>
          <div class="flex-box-center">{{choice.title}}</div>
          <p class="text-size-14 fw-400 text-color-light-2 mt-1">{{choice.description}}</p>
        </div>
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="100" fontSize="32">right</app-icon>
      </label>
    </div>
  </div>

  <p question *ngIf="editMode">Edit your home address</p>

  <form input-options #verifyAddress="ngForm" *ngIf="editMode">
    <div class="form-field mb-3">
      <input
        type="text"
        placeholder="Address line 1"
        required
        name="addressLine1"
        [(ngModel)]="customAddress.addressLine1"
        [maxLength]="128"
      />
      <p class="text-italic mt-1">Street address</p>
    </div>
    <div class="form-field mb-3">
      <input type="text" placeholder="Address line 2" name="addressLine2" [(ngModel)]="customAddress.addressLine2" [maxLength]="128" />
      <p class="text-italic mt-1">Apartment, suite, unit, building, floor etc</p>
    </div>
    <div class="form-field mb-3">
      <input type="text" placeholder="City" required name="city" [(ngModel)]="customAddress.city" [maxLength]="64" />
    </div>
    <div class="form-field mb-3">
      <input type="text" placeholder="State / Province / Region" required name="state" [(ngModel)]="customAddress.state" [maxLength]="32" />
    </div>
    <div class="form-field mb-3">
      <input type="text" placeholder="ZIP / Postal Code" required name="zip" [(ngModel)]="customAddress.zip" [maxLength]="6" />
    </div>
  </form>

  <p class="chat-answer" *ngIf="editMode" answer>
    {{ customAddress.addressLine1 }} {{ customAddress.addressLine2 }}<br />{{ customAddress.city }} {{ customAddress.state }} {{
    customAddress.zip }}
  </p>

  <div class="buttons-c" footer>
    <button *ngIf="editMode" class="w-100" (click)="updateAddress()" [disabled]="verifyAddress?.invalid">Continue</button>
    <button *ngIf="editMode" class="w-100 button-primary" (click)="editMode = false">Go back</button>
  </div>
</app-question-card>
